import { render, staticRenderFns } from "./liberarVersao.vue?vue&type=template&id=7fc7d648&"
import script from "./liberarVersao.vue?vue&type=script&lang=js&"
export * from "./liberarVersao.vue?vue&type=script&lang=js&"
import style0 from "./liberarVersao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports